import { render, staticRenderFns } from "./BetDetailModal.vue?vue&type=template&id=51c500be&scoped=true"
import script from "./BetDetailModal.vue?vue&type=script&lang=js"
export * from "./BetDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BetDetailModal.vue?vue&type=style&index=0&id=51c500be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c500be",
  null
  
)

export default component.exports